import { useQuery } from '@tanstack/react-query';
import { getOrderConversionChartData } from 'config/requests/orderConversion';
import { getUnixTime } from 'date-fns';
import { OrderConversionChartFilterValues } from 'pages/Monitoring/OrderConversionChart/OrderConversionChartFilter/OrderConversionChartFilter';
import { OrderConversionChartData } from 'types/embedded/orderConversion';

type ReturnValue = {
  data?: OrderConversionChartData;
  isLoading: boolean;
};

export function useGetOrderConversionChartData(
  filters: OrderConversionChartFilterValues,
): ReturnValue {
  const { appliedDate, timezone, merchantId, providerIds } = filters;
  const [from, to] = appliedDate ?? [];
  const period = from && to ? `${getUnixTime(from)}..${getUnixTime(to)}` : null;

  const { data, isLoading } = useQuery({
    queryKey: ['provider_external_error/chart_data', period, merchantId, providerIds],
    queryFn: () => getOrderConversionChartData({ period, timezone, merchantId, providerIds }),
    enabled: !!merchantId && !!period,
  });

  return { data, isLoading };
}
